"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _Link = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Link");

var _Link2 = _interopRequireDefault(_Link);

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _Tooltip = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Tooltip");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popup = (0, _glamor.css)({
  background: "#000",
  display: "flex",
  flexDirection: "row",
  position: "relative",
  height: "100vh",

  "& > div": {
    minWidth: "300px"
  }
});

var imgContainer = (0, _glamor.css)({
  width: "81%",
  maxWidth: "calc(100% - 300px)",
  height: "100%",
  textAlign: "center",
  position: "relative",
  minWidth: "300px",
  "& > img": {
    alignSelf: "center",
    margin: "auto",
    top: "50%",
    left: "50%",
    position: "absolute",
    transform: "translate(-50%, -50%)"
  },
  "& > span": {
    border: "2px solid rgba(255,255,255,0)",
    borderBottom: "2px solid rgba(255,255,255,0.4)",
    position: "absolute",
    width: "40px",
    height: "40px",
    top: "50%",
    left: "50%",
    marginTop: "-12px",
    marginLeft: "-20px",
    zIndex: "5",
    borderRadius: "20px"
  }
});

var footer = (0, _glamor.css)({
  overflow: "hidden",
  textAlign: "left",
  padding: "1.75%",
  position: "fixed",
  top: "0",
  right: "0",
  width: "19%",
  height: "100%",
  background: "#101010",
  overflowY: "auto"
});

var titleStyle = (0, _glamor.css)({
  display: "block",
  fontSize: (0, _css.unitRem)(1.25),
  fontWeight: 700,
  letterSpacing: "-1.5px",
  lineHeight: 1.2,
  color: "#fff",
  marginBottom: (0, _css.unitRem)(0.5)
});

var authorNameStyle = (0, _glamor.css)({
  display: "block",
  color: "#ffffff",
  fontWeight: 400,
  letterSpacing: "-0.6px",
  fontStyle: "normal",
  fontSize: (0, _css.unitRem)(0.75),
  marginBottom: (0, _css.unitRem)(0.8)
});
var descriptionStyle = (0, _glamor.css)({
  display: "block",
  color: "#ffffff",
  fontWeight: 400,
  letterSpacing: "-0.5px",
  fontStyle: "normal",
  fontSize: (0, _css.unitRem)(0.75),
  lineHeight: (0, _css.unitRem)(1),
  marginBottom: (0, _css.unitRem)(1.85)
});

var line = (0, _glamor.css)({
  display: "block",
  borderBottom: "1px solid #444",
  marginBottom: (0, _css.unitRem)(2.125)
});

var authorLinks = (0, _glamor.css)(_css.noListStyle, {
  fontSize: (0, _css.unitRem)(0.63),
  marginBottom: (0, _css.unitRem)(2.125),
  "& li": {
    display: "inline-block",
    ":after": {
      content: '"|"',
      color: _css.colors.gray,
      margin: "0 " + (0, _css.unitRem)(0.5)
    },
    "&:last-child": {
      ":after": {
        display: "none"
      }
    }
  }
});

var toolsContainer = (0, _glamor.css)({
  whiteSpace: "nowrap",
  paddingBottom: "5px",
  color: _css.colors.gray,
  marginBottom: (0, _css.unitRem)(1)
});

var toolsLabel = (0, _glamor.css)({
  display: "inline-block",
  verticalAlign: "middle",
  fontSize: (0, _css.unitRem)(0.7),
  marginTop: "-2px"
});

var toolsList = (0, _glamor.css)(_css.noListStyle, {
  display: "inline-block",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
  "& li": {
    display: "inline-block",
    margin: "0 " + (0, _css.unitRem)(0.2)
  },

  "& li:hover": {
    "& .tooltip": {
      display: "block"
    }
  }
});

var toolIcon = (0, _glamor.css)({
  marginLeft: "0.5em",
  position: "relative",
  "& img": {
    width: 20,
    height: 20
  }
});

var toolName = (0, _glamor.css)({
  display: "none",
  position: "absolute",
  borderRadius: "3px",
  top: "-16px",
  fontSize: "13px",
  color: "#777",
  left: "50%",
  transform: "translateX(-50%)",
  textTransform: "capitalize"
});

var getFeatured = function getFeatured(flag) {
  return (0, _glamor.css)({
    width: "100%",
    marginLeft: "-2px",
    position: flag ? "unset" : "absolute",
    bottom: "24px",
    marginTop: "10px",
    display: "block"
  });
};

// const getToolIconSrc = tool => R.prop(tool, {
//   megascans: '/icons/gallery/tools/megascans.png',
//   vray: '/icons/gallery/tools/vray.png',
//   '3dsmax': '/icons/gallery/tools/3ds.jpeg',
//   unity: '/icons/gallery/tools/unity.jpeg',
//   ue4: '/icons/gallery/tools/ur42.png',
//   'marmoset-toolbag': '/icons/gallery/tools/marmoset.jpeg',
//   'quixel-suite': '/icons/gallery/tools/suit.png',
//   zbrush: '/icons/gallery/tools/zbrush.png',
//   cryengine: '/icons/gallery/tools/cry.png',
//   photoshop: '/icons/gallery/tools/ps.png',
//   octane: '/icons/gallery/tools/octane.png',
//   redshift: '/icons/gallery/tools/redshift.png',
//   maya: '/icons/gallery/tools/maya.jpg',
//   worldmachine: '/icons/gallery/tools/wmlogo.jpg',
//   growfx: '/icons/gallery/tools/growfx.jpeg',
//   youtubeIcon: '/icons/gallery/youtubeIcon.svg',
// })

var packsList = (0, _glamor.css)(_css.noListStyle, {
  display: "inline-block",
  paddingBottom: "0.2rem",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
  "& li": {
    display: "inline-block",
    margin: "0 " + (0, _css.unitRem)(0.2)
  },
  "& li:hover": {
    "& span": {
      display: "block"
    }
  },

  "& a": {
    color: _css.colors.gray,
    textDecoration: "underline",
    cursor: "pointer"
  },
  "& a:hover": {
    color: "#aaa"
  }
});
var packsItem = (0, _glamor.css)({
  marginLeft: "0.5em",
  position: "relative"
});


var renderAuthorLinks = function renderAuthorLinks(authorUrl, links) {
  return _react2.default.createElement(
    "ul",
    authorLinks,
    _ramda2.default.concat([{
      label: "LEARN MORE",
      href: authorUrl
    }], links).map(function (link) {
      return _react2.default.createElement(
        "li",
        null,
        _react2.default.createElement(
          _Link2.default,
          {
            galleryPopup: true,
            href: link.href,
            target: "_blank",
            rel: "noopener noreferrer"
          },
          link.label
        )
      );
    })
  );
};

var renderTools = function renderTools(tools, toolIconsFolder) {
  return _react2.default.createElement(
    "div",
    toolsContainer,
    _react2.default.createElement("span", toolsLabel),
    _react2.default.createElement(
      "ul",
      toolsList,
      tools.map(function (tool) {
        return _react2.default.createElement(
          "li",
          { className: toolIcon },
          _react2.default.createElement(_Tooltip2.default, { toolTipText: tool }),
          _react2.default.createElement("img", { alt: "", src: toolIconsFolder + tool.toLowerCase() + ".png" })
        );
      })
    )
  );
};

var renderPacks = function renderPacks(packs) {
  return _react2.default.createElement(
    "div",
    toolsContainer,
    _react2.default.createElement(
      "span",
      toolsLabel,
      "Packs used:"
    ),
    _react2.default.createElement(
      "ul",
      packsList,
      packs.map(function (pack) {
        return _react2.default.createElement(
          "li",
          { className: packsItem },
          _react2.default.createElement(
            "a",
            { href: pack[1] },
            _react2.default.createElement(
              "span",
              null,
              pack[0]
            )
          )
        );
      })
    )
  );
};

var videoLink = (0, _glamor.css)({
  textDecoration: "none",
  color: "#2B98F0",

  "& div": {
    transition: "color 100ms"
  },

  "& :hover": {
    color: "#fff"
  }
});
var videoLinkDiv = (0, _glamor.css)({
  position: "relative",
  marginTop: (0, _css.unitRem)(4.3),
  width: "100%"
});

var videoThumbDiv = (0, _glamor.css)({
  position: "relative",
  width: "100%",
  overflow: "hidden",
  height: "calc(8.5vw)",
  minHeight: "150px",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center center"
});

var videoThumb = (0, _glamor.css)({
  maxWidth: "250px",
  marginTop: "10px"
});

var videoIcon = (0, _glamor.css)({
  maxWidth: "60px",
  maxHeight: "60px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
});

var videoTextStyles = (0, _glamor.css)({
  paddingTop: "10px",
  fontWeight: "300",
  fontSize: "15px"
});

var cloudfront = function cloudfront(path) {
  return __CLIENT__ && "https://d3uwib8iif8w1p.cloudfront.net/quixel/" + path || "";
};

var renderVideo = function renderVideo(videoID, videoText) {
  //"https://www.youtube.com/watch?v=FzoY062kY1s"
  if (videoID.indexOf("?v=") != -1) {
    videoID = videoID.slice(videoID.indexOf("?v=") + 3);
  }
  return _react2.default.createElement(
    "a",
    (0, _extends3.default)({}, videoLink, {
      target: "_blank",
      rel: "noopener noreferrer",
      href: "https://www.youtube.com/watch?v=" + videoID
    }),
    _react2.default.createElement(
      "div",
      videoLinkDiv,
      _react2.default.createElement(
        "div",
        (0, _extends3.default)({}, videoThumbDiv, {
          style: {
            backgroundImage: "url(https://img.youtube.com/vi/" + videoID + "/hqdefault.jpg)"
          }
        }),
        _react2.default.createElement("img", (0, _extends3.default)({ alt: "" }, videoIcon, { src: "/icons/gallery/youtubeIcon.svg" }))
      ),
      _react2.default.createElement(
        "div",
        videoTextStyles,
        videoText
      )
    )
  );
};

var GalleryModal = function (_React$Component) {
  (0, _inherits3.default)(GalleryModal, _React$Component);

  function GalleryModal() {
    (0, _classCallCheck3.default)(this, GalleryModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GalleryModal.__proto__ || (0, _getPrototypeOf2.default)(GalleryModal)).call(this));

    _this.onWindowResize = _this.onWindowResize.bind(_this);
    _this.onHighrezLoaded = _this.onHighrezLoaded.bind(_this);
    _this.state = {};
    _this.issizing = false;
    return _this;
  }

  (0, _createClass3.default)(GalleryModal, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (!__SERVER__) {
        window.addEventListener("resize", this.onWindowResize);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.imageData.lightboxImage.src !== nextProps.imageData.lightboxImage.src) {
        this.setState({
          highrezLoaded: false
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.onWindowResize);
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      var _this2 = this;

      if (!this.issizing) {
        this.issizing = true;
        setTimeout(function () {
          _this2.forceUpdate();
          _this2.issizing = false;
        }, 200);
      }
    }
  }, {
    key: "onHighrezLoaded",
    value: function onHighrezLoaded() {
      this.setState({
        highrezLoaded: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (__SERVER__) {
        return null;
      }

      var imageWidth = this.props.imageData.width;
      var imageHeight = this.props.imageData.height;

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      if (!this.props.isPopup) {
        windowHeight -= 60;
      }

      if (window.devicePixelRatio > 1) {
        imageWidth /= 2;
        imageHeight /= 2;
      }
      var isSmallWindow = windowWidth < 768;

      var footerWidth = windowWidth * 0.19;
      footerWidth = footerWidth < 300 ? 300 : footerWidth;

      var imgWidth = isSmallWindow ? windowWidth - 20 : windowWidth - (footerWidth + 160);

      if (imgWidth < 140) imgWidth = 140;

      imgWidth = imgWidth < imageWidth ? imgWidth : imageWidth;

      var imgHeight = windowHeight - 20;
      imgHeight = imgHeight < imageHeight ? imgHeight : imageHeight;

      var wratio = imgWidth / this.props.imageData.width;
      var hratio = imgHeight / this.props.imageData.height;
      if (wratio > hratio) {
        imgWidth = this.props.imageData.width * hratio;
      } else {
        imgHeight = this.props.imageData.height * wratio;
      }
      var imgStyles = {
        width: imgWidth,
        height: imgHeight,
        maxWidth: imgWidth,
        maxHeight: imgHeight
      };
      var largeImgStyles = {
        width: imgWidth,
        height: imgHeight,
        maxWidth: imgWidth,
        maxHeight: imgHeight,
        opacity: this.state.highrezLoaded ? 1 : 0,
        zIndex: 1
      };
      var popupContainerStyles = { minHeight: "500px" };
      var footerStyles = { minHeight: "500px" };
      var imageContainerStyles = { minHeight: "500px" };

      if (!this.props.isPopup) {
        popupContainerStyles.paddingTop = "3.75em";
        footerStyles.top = "3.75em";
        footerStyles.height = "calc(100% - 3.75em)";
      }

      if (isSmallWindow) {
        imageContainerStyles.maxWidth = "100%";
        imageContainerStyles.width = "100%";
        footerStyles.display = "none";
      }
      var spinnerDisplay = {
        display: this.state.highrezLoaded ? "none" : "inline-block"
      };
      var images = [_react2.default.createElement("img", { src: this.props.image, alt: "thumb", style: imgStyles }), _react2.default.createElement("img", {
        src: this.props.imageData.lightboxImage.src,
        alt: "original",
        style: largeImgStyles,
        onLoad: this.onHighrezLoaded
      })];
      if (!this.state.highrezLoaded) {
        images.splice(1, 0, _react2.default.createElement(_Preloader2.default, { style: spinnerDisplay }));
      }
      var toolIconsFolder = cloudfront("icons/gallery/tools/");
      if (this.props.info && this.props.info.toolIconsFolder) {
        toolIconsFolder = this.props.info.toolIconsFolder;
      }
      return _react2.default.createElement(
        "section",
        (0, _extends3.default)({}, popup, { key: "section", style: popupContainerStyles }),
        _react2.default.createElement(
          "div",
          (0, _extends3.default)({}, imgContainer, { style: imageContainerStyles }),
          images
        ),
        _react2.default.createElement(
          "div",
          (0, _extends3.default)({}, footer, { style: footerStyles }),
          this.props.author.title && this.props.author.title.length > 0 && _react2.default.createElement(
            "div",
            titleStyle,
            this.props.author.title
          ),
          this.props.author.name && this.props.author.name.length > 0 && _react2.default.createElement(
            "div",
            authorNameStyle,
            this.props.author.name
          ),
          this.props.author.url && this.props.author.url.length > 0 && renderAuthorLinks(this.props.author.url, this.props.author.links),
          this.props.author.description && this.props.author.description.length > 0 && _react2.default.createElement("div", line),
          this.props.author.description && this.props.author.description.length > 0 && _react2.default.createElement(
            "div",
            descriptionStyle,
            this.props.author.description
          ),
          this.props.tools.length > 0 && _react2.default.createElement("div", line),
          this.props.tools.length > 0 && renderTools(this.props.tools, toolIconsFolder),
          this.props.imageData.packs && this.props.imageData.packs.length > 0 && renderPacks(this.props.imageData.packs),
          this.props.imageData.video && this.props.imageData.video.length > 0 && renderVideo(this.props.imageData.video, this.props.imageData.videoText),
          _react2.default.createElement(_TextButton2.default, (0, _extends3.default)({
            className: getFeatured(this.props.imageData.video && this.props.imageData.video.length > 0)
          }, getFeatured, {
            mode: "small",
            to: this.props.onRequestForBeingFeatured,
            label: "Want to get featured in the gallery?"
          }))
        )
      );
    }
  }]);
  return GalleryModal;
}(_react2.default.Component);

exports.default = GalleryModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryPopup/GalleryModal.jsx
// module id = 2782
// module chunks = 0